import React, { createContext, ReactNode } from 'react';
import { useQuery } from '@apollo/client';

import { GET_USER_PORTFOLIOS } from '../graphql/GET_USER_PORTFOLIOS';
import { Portfolio } from '../interfaces/user';
import { renderContents } from './common';

export const PortfolioContext = createContext<Portfolio[]>([]);

interface IPortfolioContextProviderProps {
  children: ReactNode;
  userId?: string;
}

export const PortfolioContextProvider = (
  props: IPortfolioContextProviderProps
) => {
  const setVariables = props.userId
    ? {
      variables: { userId: parseInt(props.userId, 10) }
    }
    : {};

  const { loading, error, data } = useQuery(
    GET_USER_PORTFOLIOS,
    setVariables
  );

  return (
    <PortfolioContext.Provider value={(data && data.getUserPortfolios) || []}>
      {renderContents({
        children: props.children,
        data,
        error,
        loading
      })}
    </PortfolioContext.Provider>
  );
};